import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import {
  useAuth0,
  ErrorBoundary,
  USER_GROUPS,
  Iframe,
  MARKETING_PAGE,
  UNIFY_URLS,
  useGetCompany,
} from '@livingsecurity/shared';
import { useFlags } from 'launchdarkly-react-client-sdk';

import { AuthorizedLayout } from 'components';

const UnifyDashboard = ({ history }) => {
  const { user, isUserHasRights } = useAuth0();
  const hasAccess = isUserHasRights([
    USER_GROUPS.UNIFY_CUSTOMER_ADMIN,
    USER_GROUPS.UNIFY_CUSTOMER_LIMITED_ADMIN,
    USER_GROUPS.UNIFY_LS_ADMIN,
  ]);
  const { data: companyInfo } = useGetCompany();
  const { unifyUrl } = useFlags();
  const location = useLocation();
  const region = companyInfo?.region || user?.[`${process.env.REACT_APP_USER_CLAIMS_NAMESPACE}/region`];
  const url = region === 'EU' ? 'https://unify-eu.livingsecurity.com' : unifyUrl;
  const [embeddedUrl, setEmbeddedUrl] = useState(null);

  useEffect(() => {
    if (!url || !hasAccess) {
      setEmbeddedUrl(MARKETING_PAGE.UNIFY);
      return;
    }
    let path = location.pathname.replace(/^\/+|\/+$/g, '');
    if (!path.startsWith('unify')) path = `unify/${path}`;
    let fullUrl = `${url.replace(/\/+$/, '')}/${path}/`;
    if (location.search) fullUrl += location.search;
    setEmbeddedUrl(fullUrl);

    if (window.location?.href?.includes('livingsecurity.com')) {
      window.document.domain = 'livingsecurity.com';
    }
  }, [url, hasAccess, location.pathname, location.search]);

  useEffect(() => {
    if (!hasAccess && window.location?.pathname !== UNIFY_URLS.demo) {
      history.replace(UNIFY_URLS.demo);
    }
  }, [hasAccess, history]);

  return (
    <>
      <AuthorizedLayout app="UNIFY" withBottomPaddingForHubspot>
        <ErrorBoundary scope="unify-dashboard">
          {embeddedUrl && (
            <Iframe
              id="unify-embed-frame"
              allow="clipboard-read; clipboard-write *;"
              className="embedded-iframe"
              data-testid="unify-embed-frame"
              title="Living Security Unify"
              src={embeddedUrl}
            />
          )}
        </ErrorBoundary>
      </AuthorizedLayout>
    </>
  );
};

UnifyDashboard.propTypes = {
  history: PropTypes.any.isRequired,
};

export default UnifyDashboard;
